import { Route, Routes } from 'react-router-dom'

import { GardeRoute } from './auth/GardeRoute'
import { BandeauEnvironnement } from './components/BandeauEnvironnement'
import Administration from './pages/Administration'
import Connexion from './pages/Connexion'
import Dossier from './pages/Dossier'
import ListeDossiers from './pages/ListeDossiers'

/**
 * Routes de l'application.
 *
 * Rappel, ecrit aussi dans GardeRoute : ces gardes sont du confort d'affichage.
 * La securite est dans la RLS, et une route atteinte par contournement ne doit
 * jamais etre une faille.
 */
export default function App() {
  return (
    <>
      {/* Au-dessus de toutes les routes, y compris /connexion. */}
      <BandeauEnvironnement />

      <Routes>
        <Route path="/connexion" element={<Connexion />} />
        <Route
          path="/"
          element={
            <GardeRoute>
              <ListeDossiers />
            </GardeRoute>
          }
        />
        <Route
          path="/dossier/:id"
          element={
            <GardeRoute>
              <Dossier />
            </GardeRoute>
          }
        />
        <Route
          path="/administration"
          element={
            <GardeRoute adminRequis>
              <Administration />
            </GardeRoute>
          }
        />
        <Route
          path="*"
          element={
            <GardeRoute>
              <ListeDossiers />
            </GardeRoute>
          }
        />
      </Routes>
    </>
  )
}
